import styled from 'styled-components';

import { IAddOn } from '../../types';
import { AddOnButton } from '../AddOnButton';
import { breakpoints, colors } from '../../constants';
import { postDataLayerEvent } from '../../utils';

const ListTitle = styled.div``;

interface IProps {
    addOns: IAddOn[];
    className?: string;
    discountPercentage?: number;
    selectedAddOns: IAddOn[];
    onAddOnClick(addOn: IAddOn): void;
}

const BaseAddOnSelector = ({
    addOns,
    className,
    discountPercentage,
    selectedAddOns,
    onAddOnClick,
}: IProps) => {
    if (!addOns) return null;

    const handleAddOnClick = (addOn: IAddOn) => {
        onAddOnClick(addOn);

        postDataLayerEvent('Productkeuze: Klik extra optie', addOn.name);
    };

    return (
        <div className={className}>
            <ListTitle>Wil je een extra optie toevoegen?</ListTitle>
            <ul>
                {/* .sort method sorts in place so copy array first using spread  */}
                {[...addOns]
                    .sort((a, b) => a.order - b.order)
                    .map((addOn) => {
                        const isActive = !!selectedAddOns.find(
                            (i) => i.id === addOn.id
                        );

                        const excludedAddOns = selectedAddOns
                            .map(
                                (selectedAddOn) =>
                                    selectedAddOn.excludesAddOnIds
                            )
                            .flat();

                        const isDisabled = excludedAddOns.includes(addOn.id);

                        const substring = '- niet combineerbaar';

                        const addOnName = addOn.name.includes(substring)
                            ? addOn.name.replace(substring, '')
                            : addOn.name;

                        return (
                            <AddOnButton
                                addOn={addOn}
                                disabled={isDisabled}
                                discountPercentage={discountPercentage}
                                key={addOn.id}
                                name={addOnName}
                                selected={isActive}
                                onClick={() => handleAddOnClick(addOn)}
                            />
                        );
                    })}
            </ul>
        </div>
    );
};

export const AddOnSelector = styled(BaseAddOnSelector)`
    background-color: ${colors.greenLight};
    padding: 20px;

    ${ListTitle} {
        margin-bottom: 15px;

        @media (${breakpoints.mediumMin}) {
            white-space: nowrap;
        }
    }

    ul {
        display: flex;
        flex-direction: column;

        @media (${breakpoints.smallMin}) {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            grid-gap: 8px;
        }
    }

    ${AddOnButton} {
        margin-top: 10px;

        @media (${breakpoints.smallMin}) {
            margin: 0;
        }
    }
`;
